import { render, staticRenderFns } from "./BuildingShowFivePercentTab.vue?vue&type=template&id=6a482ebb"
import script from "./BuildingShowFivePercentTab.vue?vue&type=script&lang=ts"
export * from "./BuildingShowFivePercentTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports